import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalSubject = new Subject<string>();

  modal$ = this.modalSubject.asObservable();

  openModal(modalType: string) {
    this.modalSubject.next(modalType);
  }
}
